import React, {PureComponent} from 'react';
import FormCore from '../../../../components/display/form/formCore';
import PropTypes from 'prop-types';

class TransferForm extends PureComponent {
  constructor (props) {
    super(props);
    this.props = props;
    this.layout = [
      'inline', // 横向布局
      'vertical', // 弹窗布局
      'horizontal' // 纵向布局
    ];
    this.state = {
      formConfig: {
        childItems: [],
        layout: this.layout[0],
        formTarget: ''
      }
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  componentWillMount () {
    // 配置formItem的构建信息
    this.setState({
      formConfig: {
        childItems: [
          {
            type: 'transfer',
            transType: 'default',
            titles: ['from', 'to'],
            placeholder: '请搜索',
            nofound: '暂无选项',
            itemUnit: '条',
            // 通过参数key来配置source和target
            key: ['defaultSource', 'defaultTarget'],
            param: {
              name: 'choseArr',
              type: 'array'
            }
          },
          {
            type: 'transfer',
            transType: 'tree',
            titles: ['未选权限', '已选权限'],
            placeholder: '请搜索',
            nofound: '暂无选项',
            itemUnit: '条',
            key: ['treeSource', 'treeTarget'],
            param: {
              name: 'choseTreeArr',
              type: 'array'
            }
          },
          {
            type: 'buttonGp', // 表单最终执行组
            buttonArr: [
              {
                btnType: 'formSubmit',
                text: '查询'
              },
              {
                btnType: 'reset',
                text: '清空'
              }
            ]
          },
        ],
        // 设置表单元素
        layout: this.layout[this.props.layout] || this.layout[1], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
        formTarget: 'refresh', // 表单提交类型，设置grid -- 筛选更新grid， submit -- 异步请求， refresh -- 提交并更新grid
        defaultParams: { // 多个默认参数可以在这里设置，不需要使用disabled
          id: '201788888',
          defaultName: '123123'
        },
        context: this
      }
    });
  }

  fetchApi (param) {
    // 当设置formTarget不是更新grid类型时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === 'grid') {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      // TODO 执行异步请求或其他
      return;
    }
  }

  render () {
    return <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi.bind(this)}/>
  }
}

export default TransferForm;

TransferForm.propsType = {
  layout: PropTypes.string,
  modalSubmit: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/AntD/pages/example/demo/forms/transferForm.js